
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class PrismLightEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const rays = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        const draw = () => {
            for (let i = 0; i < rays; i++) {
                const angle = (i / rays) * Math.PI * 2 + curTime * 0.1;
                const rWidth = (100 + Math.sin(curTime + i) * 50) * scale;
                
                // Prism colors (approximated around pc.color)
                ctx.save();
                ctx.rotate(angle);
                ctx.globalAlpha *= 0.15 / (layerIndex + 1);
                
                const grad = ctx.createLinearGradient(0, 0, width, 0);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(0.5, 'transparent');
                grad.addColorStop(1, pc.color);
                
                ctx.fillStyle = grad;
                ctx.fillRect(0, -rWidth/2, width * 2, rWidth);
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
